import PropTypes from 'prop-types'
import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import _isArray from 'lodash/isArray'

export const PROGRESS_BAR_TYPE_GRADIENT = 'gradient'
export const PROGRESS_BAR_TYPE_ROUNDED_GRADIENT = 'roundedGradient'
export const PROGRESS_BAR_SIZE_SMALL = 'small'
export const PROGRESS_BAR_TYPE_SOLID = 'solid'

function getStyle (percent) {
  return { width: `${percent}%` }
}

function getDurationPercent (featurePosition, duration) {
  let percent = 0
  if (featurePosition && duration) {
    percent = (featurePosition / duration) * 100
  }
  if (percent > 100) {
    percent = 100
  }
  return percent
}

function getClassName (classes, type, size) {
  const baseClassName = 'progress-bar'
  const baseClassNameArray = [baseClassName]

  if (_isArray(classes)) {
    baseClassNameArray.concat(classes)
  }

  if (type === PROGRESS_BAR_TYPE_ROUNDED_GRADIENT) {
    baseClassNameArray.push(`${baseClassName}--rounded-gradient`)
  }

  if (size === PROGRESS_BAR_SIZE_SMALL) {
    baseClassNameArray.push(`${baseClassName}--small`)
  }

  if (type === PROGRESS_BAR_TYPE_SOLID) {
    baseClassNameArray.push(`${baseClassName}--solid`)
  }

  return baseClassNameArray.join(' ')
}

function getProgressBarStyleClassName (type) {
  const itemClass = ['progress-bar__progress']

  if (type === PROGRESS_BAR_TYPE_GRADIENT) {
    itemClass.push(`${itemClass}--gradient`)
  }

  if (type === PROGRESS_BAR_TYPE_ROUNDED_GRADIENT) {
    itemClass.push(`${itemClass}--rounded-gradient`)
  }

  if (type === PROGRESS_BAR_TYPE_SOLID) {
    itemClass.push(`${itemClass}--solid`)
  }

  return itemClass.join(' ')
}

function ProgressBar (props) {
  const {
    userInfo,
    duration,
    className,
    type,
    size,
  } = props
  const percent = getDurationPercent(userInfo.get('featurePosition'), duration)
  return (
    <div className={getClassName(className, type, size)}>
      <div
        className={getProgressBarStyleClassName(type)}
        style={getStyle(percent)}
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
      />
    </div>
  )
}

ProgressBar.propTypes = {
  userInfo: ImmutablePropTypes.map.isRequired,
  duration: PropTypes.number.isRequired,
  className: PropTypes.array,
  type: PropTypes.string,
  size: PropTypes.string,
}

export default ProgressBar
